// removed by extract-text-webpack-plugin
module.exports = {"container":"Expandable__container___oL5DY","childrenContainer":"Expandable__childrenContainer___2wBPh","handleContainer":"Expandable__handleContainer___3jqWB"};


//////////////////
// WEBPACK FOOTER
// ./core/src/components/Expandable/Expandable.css
// module id = 1173
// module chunks = 0